import { c as _c } from "react/compiler-runtime";
;
!function () {
  try {
    var e = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : {};
    e._sentryModuleMetadata = e._sentryModuleMetadata || {}, e._sentryModuleMetadata[new e.Error().stack] = Object.assign({}, e._sentryModuleMetadata[new e.Error().stack], {
      "_sentryBundlerPluginAppKey:localcoin": true
    });
  } catch (e) {}
}();
import { Select as NativeSelect } from '@headlessui/react';
import clsx from 'clsx';
import React from 'react';
import { useController } from 'react-hook-form';
import { ChevronDownIcon } from '@/public/assets/svg';
import type { FormSelectInputProps, SelectInputProps } from './types';
const Select = React.forwardRef<HTMLSelectElement, SelectInputProps>(({
  label,
  options,
  onChange,
  value = options[0].value
}, ref) => {
  const selectedOption = options.find(option => option.value === value);
  return <div className="flex w-full flex-col">
        <label className="text-body-8 mb-3 font-semibold text-gray-600">{label}</label>
        <div className="relative">
          <NativeSelect ref={ref} onChange={e => onChange(e.target.value)} value={selectedOption?.value} className={clsx('placeholder:text-body-8 w-full appearance-none rounded border border-gray-200 p-3', 'text-body-8 focus:border-primary-500 cursor-pointer placeholder:text-gray-400 focus:outline-hidden')}>
            {options.map(({
          value: value_0,
          label: label_0
        }) => <option key={value_0} value={value_0}>
                {label_0}
              </option>)}
          </NativeSelect>
          <ChevronDownIcon className="group pointer-events-none absolute top-3.5 right-3.5 size-4 h-4 w-4 fill-white/60" aria-hidden="true" />
        </div>
      </div>;
});
Select.displayName = 'Select';
export const FormSelect = t0 => {
  const $ = _c(12);
  let name;
  let rest;
  if ($[0] !== t0) {
    ({
      name,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = name;
    $[2] = rest;
  } else {
    name = $[1];
    rest = $[2];
  }
  let t1;
  if ($[3] !== name) {
    t1 = {
      name
    };
    $[3] = name;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const {
    field,
    fieldState
  } = useController(t1);
  let t2;
  if ($[5] !== field) {
    t2 = value => {
      field.onChange(value);
    };
    $[5] = field;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const t3 = fieldState.error?.message;
  let t4;
  if ($[7] !== field || $[8] !== rest || $[9] !== t2 || $[10] !== t3) {
    t4 = <Select {...field} {...rest} onChange={t2} error={t3} data-sentry-element="Select" data-sentry-component="FormSelect" data-sentry-source-file="index.tsx" />;
    $[7] = field;
    $[8] = rest;
    $[9] = t2;
    $[10] = t3;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  return t4;
};
export default Select;